export default {
    lastUpdated: "Última actualización",
    footer: {
        terms: "Términos y condiciones",
        privacy: "Política de privacidad",
    },
    terms: {
        title: "Términos y condiciones",
        sections: {
            acceptance: {
                title: "1. Aceptación de los términos",
                content:
                    "Al acceder o utilizar la plataforma Eve Mind, aceptas estar sujeto a estos Términos y condiciones. Si no estás de acuerdo con alguna parte de estos términos, no podrás utilizar nuestros servicios.",
            },
            useOfService: {
                title: "2. Uso del servicio",
                content:
                    "Eve Mind proporciona una plataforma de gestión del comercio y la logística. Aceptas utilizar el servicio únicamente para fines lícitos y de conformidad con estos términos. Eres responsable de mantener la confidencialidad de las credenciales de tu cuenta.",
            },
            accountSecurity: {
                title: "3. Cuenta y seguridad",
                content:
                    "Debes proporcionar información precisa y completa al crear una cuenta. Eres responsable de toda la actividad que ocurra bajo tu cuenta. Notifícanos inmediatamente cualquier uso no autorizado.",
            },
            intellectualProperty: {
                title: "4. Propiedad intelectual",
                content:
                    "Todo el contenido, las funciones y la funcionalidad de la plataforma Eve Mind son propiedad de Eve Mind y están protegidos por las leyes internacionales de derechos de autor, marcas registradas y otras leyes de propiedad intelectual.",
            },
            limitationOfLiability: {
                title: "5. Limitación de responsabilidad",
                content:
                    "En la máxima medida permitida por la ley, Eve Mind no será responsable por daños indirectos, incidentales, especiales, consecuentes o punitivos que surjan del uso del servicio.",
            },
            changes: {
                title: "6. Cambios en los términos",
                content:
                    "Podemos modificar estos términos en cualquier momento. Te notificaremos los cambios sustanciales publicando los términos actualizados en esta página y actualizando la fecha de \"Última actualización\". El uso continuado del servicio después de dichos cambios constituye aceptación.",
            },
            contact: {
                title: "7. Contacto",
                content:
                    "Para preguntas sobre estos Términos y condiciones, contáctanos en eve.mind.ai@gmail.com.",
            },
        },
    },
    privacy: {
        title: "Política de privacidad",
        sections: {
            dataWeCollect: {
                title: "1. Datos que recopilamos",
                content:
                    "Recopilamos la información que proporcionas directamente (p. ej. datos de la cuenta, información de la empresa), los datos generados por el uso de la plataforma (p. ej. datos de envíos y documentos) y datos técnicos (p. ej. dirección IP, tipo de navegador) necesarios para el funcionamiento del servicio.",
            },
            howWeUse: {
                title: "2. Cómo utilizamos los datos",
                content:
                    "Utilizamos tus datos para proporcionar, mantener y mejorar la plataforma Eve Mind, para procesar tus solicitudes, para comunicarnos contigo y para cumplir con las obligaciones legales. No vendemos tus datos personales a terceros.",
            },
            dataSharing: {
                title: "3. Compartir datos",
                content:
                    "Podemos compartir datos con proveedores de servicios que nos ayudan a operar nuestra plataforma (p. ej. alojamiento, análisis), con tu consentimiento o cuando lo exija la ley. Exigimos a dichos proveedores que protejan tus datos adecuadamente.",
            },
            retention: {
                title: "4. Conservación",
                content:
                    "Conservamos tus datos mientras tu cuenta esté activa o según sea necesario para prestarte los servicios. Podemos conservar ciertos datos durante más tiempo cuando lo exija la ley o por motivos comerciales legítimos.",
            },
            yourRights: {
                title: "5. Tus derechos",
                content:
                    "Según tu jurisdicción, puedes tener derecho a acceder, corregir, eliminar o portar tus datos personales, o a oponerte o restringir cierto procesamiento. Contáctanos en eve.mind.ai@gmail.com para ejercer estos derechos.",
            },
            cookies: {
                title: "6. Cookies y tecnologías similares",
                content:
                    "Utilizamos cookies y tecnologías similares para mantener sesiones, recordar preferencias y analizar el uso. Puedes controlar la configuración de cookies desde tu navegador.",
            },
            contact: {
                title: "7. Contacto",
                content:
                    "Para preguntas sobre esta Política de privacidad o nuestras prácticas de datos, contáctanos en eve.mind.ai@gmail.com.",
            },
        },
    },
};
